import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from 'components/forms/FormGroup';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form/lib/propTypes';

const RenderField = ({ input, label, id, type, meta: { touched, error } }) => (
  <FormGroup
    labelClasses={label ? '' : 'sr-only'}
    labelText={label}
    forValue={id}
    formGroupClasses={touched && error ? 'has-error' : ''}
    helpBlockText={touched && error ? error : ''}
    isCheckBox={type === 'checkbox'}
  >
    <input
      {...input}
      id={id}
      className={type === 'checkbox' ? '' : 'form-control'}
      type={type}
    />
  </FormGroup>
);

RenderField.defaultProps = {
  label: '',
};

RenderField.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
};

export default RenderField;
